module.exports = __webpack_public_path__ + "static/media/headerLogo.74143cf8.png";